import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  audioUnsupported: {
    id: 'Your browser does not support the audio element.',
    defaultMessage: 'Your browser does not support the audio element.',
  },
  transcriptLabel: {
    id: 'Transcript',
    defaultMessage: 'Transcript',
  },
  audioDownloadLabel: {
    id: 'Audio download',
    defaultMessage: 'Audio download',
  },
});
